import { render, staticRenderFns } from "./seguradora.vue?vue&type=template&id=e66eb0fe&scoped=true&"
import script from "./seguradora.vue?vue&type=script&lang=js&"
export * from "./seguradora.vue?vue&type=script&lang=js&"
import style0 from "./seguradora.vue?vue&type=style&index=0&id=e66eb0fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66eb0fe",
  null
  
)

export default component.exports